import { render, staticRenderFns } from "./CollaboratorManager.vue?vue&type=template&id=32f02178&scoped=true"
import script from "./CollaboratorManager.vue?vue&type=script&lang=js"
export * from "./CollaboratorManager.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorManager.vue?vue&type=style&index=0&id=32f02178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f02178",
  null
  
)

export default component.exports